import { FC } from 'react';
import Heading from '@components/primitives/heading/Heading';
import { Sizes } from '@utils/sizes';
import FormRow from '@components/primitives/form/FormRow';
import Button from '@components/primitives/button/Button';
import { toast } from 'react-toastify';
import useAuthentication from '@hooks/useAuthentication';
import { redirectAfterLoginAtom } from '@js/store/authenticationAtoms';
import { useAtomValue } from 'jotai';
import MaintenanceMessage from '@components/features/maintenanceMessage/MaintenanceMessage';
import RotatingTranslation from '@components/primitives/rotatingTranslation/RotatingTranslation';

const Login: FC = () => {
    const { azureLogin } = useAuthentication();
    const redirectAfterLogin = useAtomValue(redirectAfterLoginAtom);

    const handleLogin = () => {
        toast.dismiss();
        azureLogin(redirectAfterLogin);
    };

    return (
        <>
            <MaintenanceMessage />
            <Heading className="loginBox__heading" size={Sizes.xxl}>
                <RotatingTranslation ns="authentication" i18nKey="login.title" />
            </Heading>
            <p className="loginBox__text">
                <RotatingTranslation ns="authentication" i18nKey="login.text" />
            </p>
            <br />
            <FormRow>
                <Button testId="login__azure" primary size={Sizes.lg} onClick={handleLogin}>
                    <RotatingTranslation ns="authentication" i18nKey="login.azureButton" />
                </Button>
            </FormRow>
        </>
    );
};

export default Login;
